import React from 'react';
import { Confirm, useDelete, useNotify, useRefresh } from 'react-admin';

export const UserDeleteDialog = ({
  // @ts-ignore
  showDeleteDialog,
  // @ts-ignore
  setShowDeleteDialog,
  // @ts-ignore
  id
}) => {
  const [erase] = useDelete();
  const notify = useNotify();
  const refresh = useRefresh();
  const onCloseDeleteDialog = () => {
    setShowDeleteDialog(false);
  };

  const onDelete = () => {
    erase(
      'users',
      {
        id
      },
      {
        onSuccess: () => {
          notify('resources.users.notifications.delete.success', {
            type: 'success'
          });
          onCloseDeleteDialog();
          refresh();
        },
        onError(error: any) {
          notify(error.message, { type: 'warning' });
        }
      }
    );
  };

  return (
    <Confirm
      title="resources.users.delete.title"
      content="resources.users.delete.message"
      onConfirm={onDelete}
      isOpen={showDeleteDialog}
      onClose={onCloseDeleteDialog}
    />
  );
};
